export const adminPermissionsConst = {
  view: {
    value: "view_admin",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu administratorów!",
  },
  add: {
    value: "add_admin",
    errorMsg: "Użytkownik nie ma uprawnień do dodania administratorów!",
  },
  update: {
    value: "change_admin",
    errorMsg: "Użytkownik nie ma uprawnień do edycji administratorów!",
  },
  delete: {
    value: "delete_admin",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania administratorów!",
  },
};
